import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { WebSocketLink } from 'apollo-link-ws';
import { split } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { getMainDefinition } from 'apollo-utilities';

Vue.use(VueApollo);

const httpLink = new HttpLink({
  uri: process.env.API_PATH,
});

const wsLink = new WebSocketLink({
  uri: `${window.origin}${process.env.API_PATH}`.replace('http', 'ws'),
  options: {
    reconnect: true,
  },
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' &&
      operation === 'subscription';
  },
  wsLink,
  httpLink,
);

const defaultClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV !== 'production',
});

const apolloProvider = new VueApollo({
  defaultClient,
});

export default apolloProvider;



// WEBPACK FOOTER //
// ./src/plugins/apollo.js